import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_LOOKUP_ACTION_OK = "GET_LOOKUP_ACTION_OK";
export const GET_LOOKUP_ACTION_ERR = "GET_LOOKUP_ACTION_ERR";

export const lookupActionAction = {
  getLookupAction,
};

function getLookupActionOk(payload) {
  return { type: GET_LOOKUP_ACTION_OK, payload };
}
function getLookupActionErr(payload) {
  return { type: GET_LOOKUP_ACTION_ERR, payload };
}

function getLookupAction() {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetActionLookup)
      .then((response) => {
        dispatch(getLookupActionOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getLookupActionErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
